const IF = require( "infrontjs" );

import template from './VideoSelectionTemplate.html';

import { InAppState } from "../base/InAppState";
import './../../components/general/main-menu';
import './../../components/general/header-bar';

export class VideoSelectionState extends InAppState
{
    static ROUTE = '/videos';
    static ID = 'video-selection';

    async enter()
    {
        this.app.container.innerHTML = template;
        this.app.container.querySelectorAll( '[data-type="btnVideoCategory"]' ).forEach( btn =>
        {
            btn.addEventListener( 'click', clickEvent  =>
            {
                this.app.router.redirect( '/videos/category/' + clickEvent.currentTarget.getAttribute( 'data-video-category-id' ) );
            });
        });
    }

    async exit()
    {
        this.app.container.querySelectorAll( '[data-type="btnVideoCategory"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
    }
};
